import styled from 'styled-components';
import { Stack } from 'components/Stack';

const ImgName = styled.span`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
`;

const NoShrinkWrapper = styled.div`
  flex-shrink: 0;
`;

const DownLoadLink = styled.a`
  cursor: pointer;
`;

const AttachmentItemSection = styled(Stack)`
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
`;

export { ImgName, DownLoadLink, NoShrinkWrapper, AttachmentItemSection };
